import { ReactNode } from 'react';

import { DASHBOARD_CHART_HEIGHT } from '../../_constants/chart';

import { Box } from '@cast/design-system';

type DashboardChartFrameProps = {
  children: ReactNode;
  height?: number;
};

export const DashboardChartFrame = ({
  children,
  height = DASHBOARD_CHART_HEIGHT,
}: DashboardChartFrameProps) => (
  <Box height={height} width="100%">
    {children}
  </Box>
);
